export default __webpack_public_path__ + "static/media/ReloadIcon.eab5cd05.svg";